import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/skip-link.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import '@flixbus/honeycomb-icons-react';
import '../../packages/props-utils/prop-types.js';
import { Injecss } from '../../packages/injecss/injecss.js';

const bem = new HoneyBem('skip-link', styles);
function SkipLink(_a) {
  var {
      children,
      to,
      extraClasses,
      innerRef
    } = _a,
    rest = __rest(_a, ["children", "to", "extraClasses", "innerRef"]);
  return /*#__PURE__*/React.createElement("a", Object.assign({
    ref: innerRef,
    href: "#".concat(to),
    className: bem.b(false, extraClasses)
  }, rest), children);
}
SkipLink.displayName = 'SkipLink';
SkipLink.propTypes = {
  children: PropTypes.string.isRequired,
  extraClasses: PropTypes.string,
  to: PropTypes.string.isRequired,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.oneOfType([PropTypes.element, PropTypes.object])
  })])
};
var skipLink = Injecss(SkipLink, styles);

export { SkipLink, skipLink as default };
